import { SupplyState } from "@/api/model"

// Moving out: only these customers have a move-out timeline and a last day of responsibility.
export const moverSupplyStates = new Set<SupplyState>([
  SupplyState.futureMoveOut,
  SupplyState.movedOut,
])

// Leaving us with no active Direct Debit: the Direct Debit card shows the mover states instead of asking for a
// new Direct Debit. A partial loss keeps a fuel with us, so it manages its Direct Debit like any other customer,
// and an objected or cancelled switch is back on supply.
export const leavingSupplyStates = new Set<SupplyState>([
  ...moverSupplyStates,
  SupplyState.lossInitiated,
  SupplyState.lossComplete,
])

// Switched away with an active Direct Debit: the Direct Debit card hides "Adjust your Direct Debit" once the
// switch is complete. Movers hide it from their last day of responsibility, which the move-out timeline knows.
export const switchedAwaySupplyStates = new Set<SupplyState>([
  SupplyState.lossComplete,
])
